export const env = {
  urlBillingApi: 'VUE_APP_URL_BILLING_API',
  version: {
    tag: '0.29.0',
    buildDate: '”2026-10-09T20:45:12Z”',
    branch: 'release/0.29.0',
    commit: '92c6bf7',
    buildNumber: '41',
    repo: 'vault-cloud-billing-front',
  }
}